import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../config.js";
import e from "../../core/Error.js";
import n from "../../core/Logger.js";
import { isNone as o, isSome as s } from "../../core/maybe.js";
import r from "../Polygon.js";
import i from "../Polyline.js";
import { getGeometryParts as l, cutParams as f, offsetMagnitude as c, updatePolyGeometry as p } from "./normalizeUtilsCommon.js";
import { getInfo as u } from "./spatialReferenceUtils.js";
import { geographicToWebMercator as a, webMercatorToGeographic as h } from "./webMercatorUtils.js";
import { cut as m } from "../../tasks/geometry/cut.js";
import { simplify as g } from "../../tasks/geometry/simplify.js";
var y = n.getLogger("esri.geometry.support.normalizeUtils");

function x(t) {
  return "polygon" === t.type;
}

function d(t) {
  return "polygon" === t[0].type;
}

function w(t) {
  return "polyline" === t[0].type;
}

function j(t) {
  var e = [];
  var n = 0,
      o = 0;

  for (var _s = 0; _s < t.length; _s++) {
    var _r = t[_s];
    var _i = null;

    for (var _t = 0; _t < _r.length; _t++) {
      _i = _r[_t], e.push(_i), 0 === _t ? (n = _i[0], o = n) : (n = Math.min(n, _i[0]), o = Math.max(o, _i[0]));
    }

    _i && e.push([(n + o) / 2, 0]);
  }

  return e;
}

function R(t, n) {
  if (!(t instanceof i || t instanceof r)) {
    var _t2 = "straightLineDensify: the input geometry is neither polyline nor polygon";
    throw y.error(_t2), new e(_t2);
  }

  var o = l(t),
      s = [];

  var _iterator = _createForOfIteratorHelper(o),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _e = _step.value;
      var _t3 = [];
      s.push(_t3), _t3.push([_e[0][0], _e[0][1]]);

      for (var _o = 0; _o < _e.length - 1; _o++) {
        var _s2 = _e[_o][0],
            _r2 = _e[_o][1],
            _i2 = _e[_o + 1][0],
            _l = _e[_o + 1][1],
            _f = Math.sqrt((_i2 - _s2) * (_i2 - _s2) + (_l - _r2) * (_l - _r2)),
            _c = (_l - _r2) / _f,
            _p = (_i2 - _s2) / _f,
            _u = _f / n;

        if (_u > 1) {
          for (var _l2 = 1; _l2 <= _u - 1; _l2++) {
            var _e3 = _l2 * n,
                _o3 = _p * _e3 + _s2,
                _i4 = _c * _e3 + _r2;

            _t3.push([_o3, _i4]);
          }

          var _e2 = (_f + Math.floor(_u - 1) * n) / 2,
              _o2 = _p * _e2 + _s2,
              _i3 = _c * _e2 + _r2;

          _t3.push([_o2, _i3]);
        }

        _t3.push([_i2, _l]);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return x(t) ? new r({
    rings: s,
    spatialReference: t.spatialReference
  }) : new i({
    paths: s,
    spatialReference: t.spatialReference
  });
}

function M(t, e, n) {
  if (e) {
    var _e4 = R(t, 1e6);

    t = h(_e4, !0);
  }

  return n && (t = p(t, n)), t;
}

function P(t, e, n) {
  if (Array.isArray(t)) {
    var _o4 = t[0];

    if (_o4 > e) {
      var _n = c(_o4, e);

      t[0] = _o4 + _n * (-2 * e);
    } else if (_o4 < n) {
      var _e5 = c(_o4, n);

      t[0] = _o4 + _e5 * (-2 * n);
    }
  } else {
    var _o5 = t.x;

    if (_o5 > e) {
      var _n2 = c(_o5, e);

      t = t.clone().offset(_n2 * (-2 * e), 0);
    } else if (_o5 < n) {
      var _e6 = c(_o5, n);

      t = t.clone().offset(_e6 * (-2 * n), 0);
    }
  }

  return t;
}

function b(t, e) {
  var n = -1;

  var _loop = function _loop(_o6) {
    var s = e.cutIndexes[_o6],
        r = e.geometries[_o6],
        i = l(r);

    var _loop2 = function _loop2(_t4) {
      var e = i[_t4];
      e.some(function (n) {
        if (n[0] < 180) return !0;
        {
          var _n3 = 0;

          for (var _t5 = 0; _t5 < e.length; _t5++) {
            var _o8 = e[_t5][0];
            _n3 = _o8 > _n3 ? _o8 : _n3;
          }

          _n3 = Number(_n3.toFixed(9));

          var _o7 = -360 * c(_n3, 180);

          for (var _s3 = 0; _s3 < e.length; _s3++) {
            var _e9 = r.getPoint(_t4, _s3);

            r.setPoint(_t4, _s3, _e9.clone().offset(_o7, 0));
          }

          return !0;
        }
      });
    };

    for (var _t4 = 0; _t4 < i.length; _t4++) {
      _loop2(_t4);
    }

    if (s === n) {
      if (d(t)) {
        var _iterator2 = _createForOfIteratorHelper(l(r)),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _e7 = _step2.value;
            t[s] = t[s].addRing(_e7);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      } else if (w(t)) {
        var _iterator3 = _createForOfIteratorHelper(l(r)),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _e8 = _step3.value;
            t[s] = t[s].addPath(_e8);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    } else n = s, t[s] = r;
  };

  for (var _o6 = 0; _o6 < e.cutIndexes.length; _o6++) {
    _loop(_o6);
  }

  return t;
}

function v(_x, _x2, _x3) {
  return _v.apply(this, arguments);
}

function _v() {
  _v = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, n, l) {
    var h, y, x, d, w, j, R, L, U, k, A, z, I, _iterator4, _step4, _t12, _e13, _e14, _e15, _n5, _o11, X, q, C, D, _t7, _t8, _n4, _o10, _l3, _r4, _r5, _i6, _r3, _i5, _e11, _t9, E, _t10, _e12, _t11;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (Array.isArray(e)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", v([e], n));

          case 2:
            y = null != (h = null == n ? void 0 : n.url) ? h : t.geometryServiceUrl;
            A = 0;
            z = [], I = [];
            _iterator4 = _createForOfIteratorHelper(e);

            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                _t12 = _step4.value;
                if (o(_t12)) I.push(_t12);else if (x || (x = _t12.spatialReference, d = u(x), w = x.isWebMercator, L = w ? 102100 : 4326, j = f[L].maxX, R = f[L].minX, U = f[L].plus180Line, k = f[L].minus180Line), d) {
                  if ("mesh" === _t12.type) I.push(_t12);else if ("point" === _t12.type) I.push(P(_t12.clone(), j, R));else if ("multipoint" === _t12.type) {
                    _e13 = _t12.clone();
                    _e13.points = _e13.points.map(function (t) {
                      return P(t, j, R);
                    }), I.push(_e13);
                  } else if ("extent" === _t12.type) {
                    _e14 = _t12.clone()._normalize(!1, !1, d);
                    I.push(_e14.rings ? new r(_e14) : _e14);
                  } else if (_t12.extent) {
                    _e15 = _t12.extent, _n5 = c(_e15.xmin, R) * (2 * j);
                    _o11 = 0 === _n5 ? _t12.clone() : p(_t12.clone(), _n5);
                    _e15.offset(_n5, 0), _e15.intersects(U) && _e15.xmax !== j ? (A = _e15.xmax > A ? _e15.xmax : A, _o11 = M(_o11, w), z.push(_o11), I.push("cut")) : _e15.intersects(k) && _e15.xmin !== R ? (A = _e15.xmax * (2 * j) > A ? _e15.xmax * (2 * j) : A, _o11 = M(_o11, w, 360), z.push(_o11), I.push("cut")) : I.push(_o11);
                  } else I.push(_t12.clone());
                } else I.push(_t12);
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }

            X = c(A, j), q = -90;
            C = X, D = new i();

            for (; X > 0;) {
              _t7 = 360 * X - 180;
              D.addPath([[_t7, q], [_t7, -1 * q]]), q *= -1, X--;
            }

            if (!(z.length > 0 && C > 0)) {
              _context.next = 28;
              break;
            }

            _context.t0 = b;
            _context.t1 = z;
            _context.next = 15;
            return m(y, z, D, l);

          case 15:
            _context.t2 = _context.sent;
            _t8 = (0, _context.t0)(_context.t1, _context.t2);
            _n4 = [];
            _o10 = [];

            for (_l3 = 0; _l3 < I.length; _l3++) {
              _r4 = I[_l3];
              if ("cut" !== _r4) _o10.push(_r4);else {
                _r5 = _t8.shift(), _i6 = e[_l3];
                s(_i6) && "polygon" === _i6.type && _i6.rings && _i6.rings.length > 1 && _r5.rings.length >= _i6.rings.length ? (_n4.push(_r5), _o10.push("simplify")) : _o10.push(w ? a(_r5) : _r5);
              }
            }

            if (_n4.length) {
              _context.next = 22;
              break;
            }

            return _context.abrupt("return", _o10);

          case 22:
            _context.next = 24;
            return g(y, _n4, l);

          case 24:
            _r3 = _context.sent;
            _i5 = [];

            for (_e11 = 0; _e11 < _o10.length; _e11++) {
              _t9 = _o10[_e11];
              "simplify" !== _t9 ? _i5.push(_t9) : _i5.push(w ? a(_r3.shift()) : _r3.shift());
            }

            return _context.abrupt("return", _i5);

          case 28:
            E = [];

            for (_t10 = 0; _t10 < I.length; _t10++) {
              _e12 = I[_t10];
              if ("cut" !== _e12) E.push(_e12);else {
                _t11 = z.shift();
                E.push(!0 === w ? a(_t11) : _t11);
              }
            }

            return _context.abrupt("return", Promise.resolve(E));

          case 31:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _v.apply(this, arguments);
}

function L(t) {
  var _ref;

  if (!t) return null;
  var e = t.extent;
  if (!e) return null;
  var n = t.spatialReference && u(t.spatialReference);
  if (!n) return e;

  var _n$valid = _slicedToArray(n.valid, 2),
      o = _n$valid[0],
      s = _n$valid[1],
      r = 2 * s,
      i = e.width;

  var l,
      f = e.xmin,
      c = e.xmax;
  if ((_ref = [c, f], f = _ref[0], c = _ref[1], _ref), "extent" === t.type || 0 === i || i <= s || i > r || f < o || c > s) return e;

  switch (t.type) {
    case "polygon":
      if (!(t.rings.length > 1)) return e;
      l = j(t.rings);
      break;

    case "polyline":
      if (!(t.paths.length > 1)) return e;
      l = j(t.paths);
      break;

    case "multipoint":
      l = t.points;
  }

  var p = e.clone();

  for (var _u2 = 0; _u2 < l.length; _u2++) {
    var _t6 = l[_u2][0];
    _t6 < 0 ? (_t6 += s, c = Math.max(_t6, c)) : (_t6 -= s, f = Math.min(_t6, f));
  }

  return p.xmin = f, p.xmax = c, p.width < i ? (p.xmin -= s, p.xmax -= s, p) : e;
}

function U(t, e) {
  var n = u(e);

  if (n) {
    var _n$valid2 = _slicedToArray(n.valid, 2),
        _e10 = _n$valid2[0],
        _o9 = _n$valid2[1],
        _s4 = _o9 - _e10;

    if (t < _e10) for (; t < _e10;) {
      t += _s4;
    }
    if (t > _o9) for (; t > _o9;) {
      t -= _s4;
    }
  }

  return t;
}

export { L as getDenormalizedExtent, v as normalizeCentralMeridian, U as normalizeMapX, R as straightLineDensify };